/** Types */
export type AuthConfig = {
  method: 'cookie' | 'apiKey';
  proxyPath: string;
};

/**
 * @description This configuration determines how the authentication for the fetch requests will be handled,
 * either through cookies (directly call the Symfony API) or API keys (through a proxy where we attach an Authorization header).
 *
 * ** KEYS **
 * - `method`: The authentication method, either 'cookie' or 'apiKey'.
 * - `proxyPath`: The path to the proxy API route that will handle API requests when using API keys.
 */
export const authConfig: AuthConfig = {
  method: 'cookie',
  proxyPath: '/api/bj',
};
